import { RefObject } from 'react';
import { useRouter } from 'next/router';

import { LinkField } from '@sitecore-jss/sitecore-jss-nextjs';

export function useLoginReturnUrl(element?: RefObject<HTMLDivElement>): {
	getLoginUrlWithReturnDestination: (linkField?: LinkField) => string;
	getLoginReturnDestination: () => string;
	getLoginReturnDestinationForElement: () => void;
} {
	const router = useRouter();

	function getLoginUrlWithReturnDestination(linkField?: LinkField): string {
		let loginUrl = linkField?.value?.href ?? '/Login';
		const currentPath = router.asPath.substring(0, router.asPath.lastIndexOf('?') > -1 ? router.asPath.lastIndexOf('?') : undefined);
		loginUrl += `?returnUrl=${currentPath.split('#')[0]}`;

		return loginUrl;
	}

	function getLoginReturnDestination(): string {
		let url = '/';

		if (router.query?.returnUrl) {
			url = `${router.query.returnUrl}`;
		}

		return url;
	}

	function getLoginReturnDestinationForElement(): void {
		if (!element || !element.current) {
			return;
		}

		const anchors = element.current.querySelectorAll('a');

		anchors.forEach((anchor) => {
			if (!anchor.href.match(/login$/i)) {
				return;
			}

			anchor.href = `/Login?returnUrl=${router.asPath.split(/[?#]/)[0]}`;
		});
	}

	return {
		getLoginUrlWithReturnDestination,
		getLoginReturnDestination,
		getLoginReturnDestinationForElement,
	};
}
